"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranshipmentHistoryColumnProps = exports.TranshipmentColumnProps = void 0;
const constants_1 = require("utils/constants");
const TranshipmentColumnProps = [
    {
        show: true,
        field: 'type',
        title: 'Type',
        width: '140',
        locked: true,
        filter: 'text'
    }, {
        show: true,
        field: 'brand_name',
        title: 'Brand',
        locked: true,
        width: '120',
        filter: 'text'
    },
    {
        show: true,
        field: 'jan',
        title: 'Jan',
        width: '125',
        filter: 'text'
    },
    {
        show: true,
        field: 'feb',
        title: 'Feb',
        width: '125',
        filter: 'text'
    },
    {
        show: true,
        field: 'mar',
        title: 'Mar',
        width: '125',
        filter: 'text'
    },
    {
        show: true,
        field: 'apr',
        title: 'Apr',
        width: '125',
        filter: 'text'
    },
    {
        show: true,
        field: 'may',
        title: 'May',
        width: '125',
        filter: 'text'
    },
    {
        show: true,
        field: 'jun',
        title: 'Jun',
        width: '125',
        filter: 'text'
    },
    {
        show: true,
        field: 'jul',
        title: 'Jul',
        width: '125',
        filter: 'text'
    },
    {
        show: true,
        field: 'aug',
        title: 'Aug',
        width: '125',
        filter: 'text'
    },
    {
        show: true,
        field: 'sep',
        title: 'Sep',
        width: '125',
        filter: 'text'
    },
    {
        show: true,
        field: 'oct',
        title: 'Oct',
        width: '125',
        filter: 'text'
    },
    {
        show: true,
        field: 'nov',
        title: 'Nov',
        width: '125',
        filter: 'text'
    },
    {
        show: true,
        field: 'dec',
        title: 'Dec',
        width: '125',
        filter: 'text'
    }
];
exports.TranshipmentColumnProps = TranshipmentColumnProps;
const TranshipmentHistoryColumnProps = [
    {
        show: true,
        field: 'action',
        title: 'Action',
        width: '75',
        sortable: false,
        filterable: false,
    },
    {
        show: true,
        field: 'filename',
        title: 'File Name',
        width: '300',
        filter: 'text',
    },
    {
        show: true,
        field: 'year',
        title: 'Year',
        width: '110',
        filter: 'text',
    },
    {
        show: true,
        field: 'status',
        title: 'Status',
        width: '110',
        filter: 'text',
    },
    {
        show: true,
        field: 'log_message',
        title: 'Log',
        width: '110',
        sortable: false,
        filterable: false,
    },
    {
        show: true,
        field: 'uploaded_at',
        title: 'Uploaded At',
        width: '175px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'uploaded_by',
        title: 'Uploaded by',
        width: '175px',
        filter: 'text'
    },
];
exports.TranshipmentHistoryColumnProps = TranshipmentHistoryColumnProps;
